<!-- sqm 不良申诉 -->
<template>
  <h-list-page class="testequipstyle">
  <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
    <h-area>
      <h-search :title="h_i18n('93088b3ee041cfcf2c25b1b3ddd5fef1')">
        <h-select filterable
          v-model="searchData.badTypename"
          :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
          clearable
          style="width:100%"
        >
          <h-option value="现场不良" :label="h_i18n('192da253760c41cbab573083fc3c7d5d')"></h-option>
          <h-option value="入厂不合格" :label="h_i18n('1d3da79822f03f22f73ca43974d8a15a')"></h-option>
          <h-option value="实验不合格" :label="h_i18n('f5a6a3a1e5bcddf045542b92ff04a564')"></h-option>
          <h-option value="停检单" :label="h_i18n('0addf9d81daedc6979addd92d00e46c1')"></h-option>
          <h-option value="纠偏单" :label="h_i18n('f37dba0758deb9ad0bead5f15776dd35')"></h-option>
          <h-option value="8D整改单" :label="h_i18n('34d22f83ae2b434ad919397ed951b25e')"></h-option>
          <h-option value="差异化供应商市场不良品" :label="h_i18n('42BDBB277A143FAB6DA9941628785915')"></h-option>
          <h-option value="破坏性实验补料" :label="h_i18n('7CA6AFBB33477479BD9B344FA1B50A90')"></h-option>
        </h-select>
      </h-search>
             <h-search :title="h_i18n('5b15bb20b0530ea7336b62440d78d417')">
         <h-input
           v-model="searchData.appealId"
           clearable
           :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')"
         ></h-input>
       </h-search>
             <h-search :title="h_i18n('96ad1b86c31e8f1965a3fdafae75975d')">
         <h-input
           v-model="searchData.badId"
           clearable
           :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')"
         ></h-input>
       </h-search>
       <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
         <h-input
           v-model="searchData.mtlNo"
           clearable
           :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')"
         ></h-input>
       </h-search>
      <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
         <h-input
           v-model="searchData.mtlName"
           clearable
           :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')"
         ></h-input>
       </h-search>
             <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
         <h-select
           :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable
           v-model="searchData.statusChangeId"
           clearable
           @change="statusChange"
         >
           <h-option value="待审核" :label="h_i18n('5cb424765cb101866f47ca115605ce3b')"></h-option>
           <h-option value="待终判" :label="h_i18n('9109d5ff67cfd588c1d5265d160a958f')"></h-option>
           <h-option value="终判通过" :label="h_i18n('db6e70ed7144c383e800dd36fe849cdf')"></h-option>
           <h-option value="终判不通过" :label="h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')"></h-option>
         </h-select>
       </h-search>
       <h-search :title="h_i18n('8f22e1b0d934d2cfc729a71d5f0c74ff')">
         <h-date-picker @change="TimeChange(searchData.DateOne, {start:'beginDateOne',end:'endDateOne'})" v-model="searchData.DateOne"
           type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
       </h-search>
       <template #operate>
         <h-button type="primary" :loading="loading" @click="onSearch()">
             <template #icon>
               <search />
             </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
       </template>
      
      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('4cbd267973099462346173a3cc9396b5')" :is-left="0" :is-right="0" :h-data="data.rejectsReplenishmentData">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-if="item.code == 'mkhl_blss_blss_insert'">
              <h-button type="warning" @click="createAppeal">
                <Newlybuild size="14"/>{{ h_i18n('82a5a964e5824da60ed4be9cf70c0c9a') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_blss_blss_export'">
              <h-button :loading="data.exportLoading" type="primary" @click="exportClick">
                <Download size="14"/>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            </template>
          </template>
          <div style="display: flex;align-items: center;margin-left: 20px;color: #2164F5;font-size: 16px">{{ h_i18n('0ad5c025a7bd9708d0a2d77647b036a4') }}</div>
          <div class="tipBox_yellow">
            <img src="@/assets/img/tips-icon.png" class="tip-img" />
            {{ h_i18n('1B546F5455FD31F9D24E65E10AF4D00A') }}
            <span style="cursor: pointer; display: flex;align-items: center;margin-left: 20px;color: #2164F5;font-size: 16px"
            @click="data.appealTableShow = true">{{ h_i18n('523DE0579A7A1BA02888C5C8BA63672A') }}</span>
          </div>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" height="540" border 
      :data="data.rejectsReplenishmentData" size="small" style="width: 100%; min-height: 540px">
        <el-table-column prop="appealStatus" :label="h_i18n('45e07169ff62da631919d80b3beffaa2')"></el-table-column>
        <el-table-column prop="appealId" :label="h_i18n('5b15bb20b0530ea7336b62440d78d417')" width="160">
          <template #default="{ row }">
            <a style="text-decoration: none">
              <span @click="checkoutClick(row)" style="color:#2681FF;cursor: pointer;">
                {{ row.appealId }}
              </span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="badId" :label="h_i18n('96ad1b86c31e8f1965a3fdafae75975d')" width="180"></el-table-column>
        <el-table-column prop="badTypename" :label="h_i18n('93088b3ee041cfcf2c25b1b3ddd5fef1')" width="200"></el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
        <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" width="130"></el-table-column>
        <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" width="200"></el-table-column>
        <el-table-column prop="number" :label="h_i18n('0bf60b32f9db93b87e08763b1c815469')"></el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" width="100"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200"></el-table-column>
        <el-table-column prop="inputName" :label="h_i18n('e998e6528503388a3f348a8fc0ec072b')" width="100"></el-table-column>
        <el-table-column prop="inputDate" :label="h_i18n('df44473bef692a048da1381709f16098')" width="120">
          <template #default="{ row }">
            <span>{{ time(row.inputDate) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getTableData"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.count">
      </el-pagination>
    </h-table-card>
    <el-dialog :title="h_i18n('523DE0579A7A1BA02888C5C8BA63672A')" v-model="data.appealTableShow" @close="data.appealTableShow = false" width="960px">
      <el-table empty-text="暂无数据" class="myTable" size="small" style="width: 100%;border-radius: 8px;border:1px solid #E5E6EB;border-bottom: none;border-color:#E5E6EB !important;margin-top: -14px;"
       :data="data.appealTableData">
        <el-table-column prop="title" :label='h_i18n("5497891BECF54E5B19FAB5273B595E5F")' min-width="100"></el-table-column> 
        <el-table-column prop="date" :label='h_i18n("A5CBE15F82AF1E9CFC58632C6EE1B07B")' min-width="300"></el-table-column>
      </el-table>
    </el-dialog>
  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated ,ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
const { proxy, ctx } = getCurrentInstance()

    const router = useRouter();
    const route = useRoute()
    let expents = ref(false);
    let sumOfTableWidth = ref(0);
    const searchData = reactive({
        badTypename: '',
        pageNo: 1,
        pageSize: 10,
        badId: "",
        mtlNo: "",
        mtlName: "",
        beginDateOne: "",
        endDateOne: "",
        supplyCode: "",
        jiaohuStatus: null,
        rejectStatus: null,
        rejectsType: null,
        xcType: "PC1",
        sybId: "",
        isrtEmpName: "",
        queryFlag: "sqm",
        relatedRoleId: "8",
        supplyName: "",
        sybName: null,
        supplyCode: "",
      })
    const data = reactive({
      appealTableData:[
        // 93fbc4b2599c08ddc368dfc24ca259e2 现场退次 // 0a1dc2c808febcb6b98af8df2f0b67e9 检验负责人
      {title:h_i18n('93fbc4b2599c08ddc368dfc24ca259e2'),date:h_i18n('2C35F7768BE4462FE722DDFF087F3D84')},
      // "1d3da79822f03f22f73ca43974d8a15a": "入厂不合格",// 4ed5b49161457958596caef59bfc60b0 质量部长
      {title:h_i18n('1d3da79822f03f22f73ca43974d8a15a'),date:h_i18n('2C35F7768BE4462FE722DDFF087F3D84')}, 
      // "f5a6a3a1e5bcddf045542b92ff04a564": "实验不合格",// 15个自然日 9BECA7C073314F5EA49DA8ACC84E7141
      {title:h_i18n('f5a6a3a1e5bcddf045542b92ff04a564'),date:h_i18n('9BECA7C073314F5EA49DA8ACC84E7141')},
      // "0addf9d81daedc6979addd92d00e46c1": "停检单",
      {title:h_i18n('0addf9d81daedc6979addd92d00e46c1'),date:h_i18n('9BECA7C073314F5EA49DA8ACC84E7141')},
      // "f37dba0758deb9ad0bead5f15776dd35": "纠偏单",
      {title:h_i18n('f37dba0758deb9ad0bead5f15776dd35'),date:h_i18n('2C35F7768BE4462FE722DDFF087F3D84')},
      // 34d22f83ae2b434ad919397ed951b25e": "8D整改单", // 5个自然日 2C35F7768BE4462FE722DDFF087F3D84
      {title:h_i18n('34d22f83ae2b434ad919397ed951b25e'),date:h_i18n('2C35F7768BE4462FE722DDFF087F3D84')}, 
      // 差异化供应商市场不良品 10个自然日
      {title:h_i18n('42BDBB277A143FAB6DA9941628785915'),date:h_i18n('40D2F6D0D18AE8FCC91FD55E7CDA6C18')}, 
      // 破坏性实验补料
      {title:h_i18n('7CA6AFBB33477479BD9B344FA1B50A90'),date:h_i18n('2C35F7768BE4462FE722DDFF087F3D84')}, 
      ],
      appealTableShow:false,
      fetching: false, //搜索动画
      count: 0,
      rejectsReplenishmentData: [],
      selectedRowKeysArray: [],
      selectedRowsArray: [],
      factoryArray: [],
      factorysStatus: false,
      tableLoading: false,
      exportLoading:false,
      statusChangeId: undefined,
      userName:undefined,
      btnCodeList:[
                "mkhl_blss_blss_insert","mkhl_blss_blss_export"
                ],
                btnListOfSqm:[]
    });
    // 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_blss_blss_insert":
    
    break;
    case "mkhl_blss_blss_export":
    
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_blss_blss_insert":
    return 
    case "mkhl_blss_blss_export":
    return 
  }
}

    /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};

    const onSelectChange = (selectedRowKeys, selectedRows) => {
      // console.log(selectedRowKeys, selectedRows);
      data.selectedRowKeysArray = selectedRowKeys;
      data.selectedRowsArray = selectedRows;
    };
    const statusChange = (val) =>{
      searchData.appealStatus = val

    }
    // 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
};

    // 查询
    const onSearch = () => {
      getTableData(true);
    };
    // 申诉
    const appealClick = () => {
      if (data.selectedRowsArray.length == 0) {
        warning({ title: h_i18n('900c70fa5f7dbc014e6f762d5e0e885c'), v1: [h_i18n('03c92754679c53af03423938b1118fcc')] });
        return;
      }
    };
    // 创建申诉
    const createAppeal = () => {
       router.push({
        path:"/addAppeal",
        query: {//要传的参数
          supplyCode:searchData.supplyCode,
          supplyName:searchData.supplyName,
          applyName:searchData.applyName,
          trueName:searchData.trueName,
          userName:data.userName,
          dataFrom:'sqm',
          kindType:'sqmAdd'
        }
      });
      // window.open(href, '_blank');//打开新的窗口
      // router.push("appealPage")
    };
    // 导出
    const exportClick = () => {
      if(data.count > 5000) {
        proxy.warning(
          { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
          {
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: (action) => { },
          }
        );
        return;
      }
      data.exportLoading = true;
      proxy.startLoading(h_i18n('33ef688cad0e5b2b05ad13f8357d5ab3'));
      proxy.httpFile(
        {
          method: "get",
          url: "/base/RefusalAppeal/Supperexport",
          params: {
            ...searchData,
            DateOne:undefined,
          },
          data:{},
        },
        h_i18n('f516033f8a9c927a4e8eb31aa731e88b')
      ).then(res=>{
        data.exportLoading = false;
      }).catch(err=>{
        data.exportLoading = false;
        proxy.closeLoading()
      })
    };
    const getTableData = (flag) => {
      data.tableLoading = true;
      if (flag == true) {
        searchData.pageNo = 1; // 每次查询默认页面为1
      }
      proxy.$http({
        method: "post",
        // url: '/unload/rejectsReplenishment/rejectsReplenishmentList',
        url: "/base/RefusalAppeal/supperSelectAppealLIst",
        data: {
          ...searchData,
          DateOne:undefined,
        }
      }).then((res=>{
          if (res.data.data.records) {
            data.rejectsReplenishmentData = res.data.data.records;
            data.count = res.data.data.total;
          } else {
            data.count = 0;
            data.rejectsReplenishmentData = [];
          }
        })).catch(err=>{
          console.log(err);
        }).finally(()=>{
          data.tableLoading = false;
        })
    };
    // 切换旧版
  const backOldVersion = () => {
    if (process.env.NODE_ENV != 'production') {
      window.open(`https://pre-hmqm-server.haier.net/mkhl/#/newMain/appeal?supplyCode=${data.supplyCode}&supplyName=${data.supplyName}&trueName=${data.trueName}&userName=${data.userName}&roleCode=${data.roleCode}`)
    }else{
      window.open(`https://sqmnew.haier.net/sqmnewfront/#/newMain/appeal?supplyCode=${data.supplyCode}&supplyName=${data.supplyName}&trueName=${data.trueName}&userName=${data.userName}&roleCode=${data.roleCode}`)
    }
  }
    // 查看
    const checkoutClick = (val) => {
      router.push({
        path:"/addAppeal",
        query: {//要传的参数
          supplyCode:searchData.supplyCode,
          supplyName:searchData.supplyName,
          applyName:searchData.applyName,
          trueName:searchData.trueName,
          nickName:searchData.trueName,
          userName:data.userName,
          dataFrom:'sqm',
          kindType:'sqmDetail',
          badTypename:val.badTypename,
          appealId:val.appealId,
          type: val.type? val.type : null
        }
      })
      
    }
    const setDate = () => {
      searchData.DateOne = [new Date().getTime() - 24 * 30 * 60 * 60 * 1000 , new Date()]
      searchData.beginDateOne = proxy.time(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)
      searchData.endDateOne = proxy.time(new Date())
    }
    onMounted(() => {
      if(route.query){
        data.userName = route.query.userName
      }
      if(route.query.dataFrom != 'sqm'){
        proxy.$router.replace('/404')
        return
      }
      if(!route.query.supplyCode){
        proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => { 
            proxy.$router.back()        
          },})
        return
      }
      if (route.query) {
        searchData.supplyCode = route.query.supplyCode;
        searchData.supplyName = route.query.supplyName;
        searchData.trueName = route.query.trueName||route.query.nickName;
        data.roleCode = route.query.roleCode;
        data.userName = route.query.userName;
        data.supplyCode = route.query.supplyCode;
        data.supplyName = route.query.supplyName;
        data.trueName = route.query.trueName||route.query.nickName;
        searchData.applyName = route.query.userName||route.query.nickName;
      }
      if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }else{
    data.btnListOfSqm = [{code:"mkhl_blss_blss_insert",name:'创建申诉'},{code:"mkhl_blss_blss_export",name:'导出'}]
  }
      
      setDate()
      getTableData(true);
    });

</script>

<style lang="scss">

</style>
